import React, { useRef, useState } from "react";
import Lottie from "lottie-react";
import Slider from "react-slick";
import cyberAnimation from "../../lotties/cyber-security_14644936.json";
import cryptoAnimation from "../../lotties/cryptocurrency_10470934.json";
import blockchainAnimation from "../../lotties/blockchain_16866018.json";

const Ciphegis = () => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      icon: cyberAnimation,
      description: "Ciphegis is a decentralized security audit marketplace that connects blockchain projects with security experts to identify vulnerabilities and strengthen smart contracts."
    },
    {
      icon: cryptoAnimation,
      description: "Traditional audits are expensive, centralized, and slow. Current processes gatekeep by enabling developers to request audits and launch bug bounty programs, while security researchers can be rewarded in $CPH tokens."
    },
    {
      icon: blockchainAnimation,
      description: "With on-chain transparency, staking incentives, and community governance, Ciphegis is redefining blockchain security— efficient, decentralized, and built for Web3."
    }
  ];
  const cards2 = [
    {
      number: "01",
      title: "Access to Affordable, Decentralized Security Audits",
      description: "No need to rely on centralized, high-cost firms like CertiK. Developers can post audit requests and choose from a pool of vetted security experts at competitive prices. Faster, scalable smart contract verification.",
    },
    {
      number: "02",
      title: "Bug Bounty Programs to Strengthen Smart Contracts",
      description: "Developers can launch bounty programs to incentivize ethical hackers to find vulnerabilities. Instead of waiting for audits, developers get continuous security validation from the global audit community.",
    },
    {
      number: "03",
      title: "Transparent, On-Chain Security Reports",
      description: "All audits and bug bounties are recorded on-chain, ensuring verifiable security history. Developers can prove contract security to investors and users with publicly accessible security reports.",
    }
  ];
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  return (
    <section className="relative h-auto min-h-screen py-20" id="Ciphegis">
      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        {/* Title */}
        <div className="text-center lg:text-start min-[1530px]:ml-28 mb-16 relative">
          <div className="flex flex-col mb-2 pt-16 gap-4">
            <span className="text-4xl sm:text-5xl font-light text-white">WHAT IS</span>
            <span className="text-4xl sm:text-5xl font-bold text-[#22C8BF]">CIPHEGIS ?</span>
          </div>
        </div>

        {/* Grid for smaller screens */}
        <div className="hidden lg:flex justify-center items-center gap-8">
          {cards.map((card, index) => (
            <div
              key={index}
              className="h-[533px] w-[428px] flex flex-col justify-center items-center border-[#22C8BF] border-t-8 bg-white px-16 text-center transform hover:scale-110 transition-transform duration-300"
            >
              <div className="w-[150px] h-[150px] mx-auto mb-20">
                <Lottie
                  animationData={card.icon}
                  loop={true}
                  autoplay={true}
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
              <p className="text-base leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
        <div className="hidden lg:flex justify-center items-center gap-8">
          {cards2.map((card, index) => (
            <div
              key={index}
              className="h-[533px] w-[428px] border-b-8 border-[#22C8BF] flex flex-col items-start px-8 py-12 bg-gradient-to-b from-transparent to-[#1A1A1A] backdrop-blur-sm hover:scale-110 transition-transform duration-300"
            >
              <span className="text-[106px] font-light text-white mb-6">{card.number}</span>
              <h3 className="text-[#22C8BF] text-2xl font-semibold mb-6 max-w-[200px]">{card.title}</h3>
              <p className="text-white/80 text-base leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
        {/* Carousel for xl screens */}
        <div className="lg:hidden relative">
          <Slider ref={sliderRef} {...settings}>
            {cards.map((card, idx) => (
              <div key={idx} className="flex justify-center items-center">
                <div className="sm:h-[530px] sm:w-[400px] w-[330px] h-[500px] flex flex-col justify-center items-center border-[#22C8BF] border-t-8 bg-white px-16 text-center mx-auto">
                  <div className="lg:w-[180px] lg:h-[180px] w-[150px] h-[150px] mx-auto mb-20">
                    <Lottie
                      animationData={card.icon}
                      loop={true}
                      autoplay={true}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                  <p className="text-base leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="lg:hidden relative">
          <Slider ref={sliderRef} {...settings}>
            {cards2.map((card, idx) => (
              <div key={idx} className="flex justify-center items-center">
                <div className="sm:h-[530px] sm:w-[400px] w-[330px] h-[500px] border-b-8 border-[#22C8BF] flex flex-col items-start px-8 sm:py-12 py-4 bg-gradient-to-b from-transparent to-[#1A1A1A] backdrop-blur-sm mx-auto">
                  <span className="text-[106px] font-light text-white mb-4">{card.number}</span>
                  <h3 className="text-[#22C8BF] text-2xl font-semibold mb-4 max-w-[200px]">{card.title}</h3>
                  <p className="text-white/80 text-base leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Ciphegis;